import { createContext } from 'react';
export const DEFAULT_SCROLL_AREA_OVERFLOW = {
    canScrollUp: false,
    canScrollDown: false,
};
export const ScrollAreaContext = createContext(DEFAULT_SCROLL_AREA_OVERFLOW);
//# sourceMappingURL=ScrollAreaContext.js.map